import React, { useState, useEffect } from 'react';
import '../css/dashboard.css';
import '../css/dadosCadastrais.css';
import ModalNfe from "./modalNfe";
import ModalBoletoDigital from "./modalBoletoDig";
import ModalEmailIndividual from "./modalEmailIndividual";
import ModalBoletoConfig from "./modalBoletoConfig";
import ModalTelefoneIndividual from "./modalTelefoneIndividual";
import { Info } from 'lucide-react';
import { FiEdit } from 'react-icons/fi';
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { formatCNPJ } from '../../utils/format';
import BoletoService from "../../modules/services/BoletoService";

// Função para formatar telefone
function formatTelefone(numero) {
    if (!numero) return '';
    const tel = numero.replace(/\D/g, '');
    let ddi = '';
    let ddd = '';
    let num = '';
    if (tel.length > 11) {
        ddi = '+' + tel.slice(0, tel.length - 11) + ' ';
        ddd = '(' + tel.slice(-11, -9) + ') ';
        num = tel.slice(-9, -4) + '-' + tel.slice(-4);
    } else if (tel.length === 11) {
        ddd = '(' + tel.slice(0, 2) + ') ';
        num = tel.slice(2, 7) + '-' + tel.slice(7);
    } else if (tel.length === 10) {
        ddd = '(' + tel.slice(0, 2) + ') ';
        num = tel.slice(2, 6) + '-' + tel.slice(6);
    } else {
        num = tel;
    }
    return `${ddi}${ddd}${num}`;
}

function DadosCadastrais({ cliente, onClienteUpdate }) {
    console.log('📋 DadosCadastrais: Cliente recebido:', cliente);
    console.log('📋 DadosCadastrais: Emails do cliente:', cliente?.emails);
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalBoletoOpen, setIsModalBoletoOpen] = useState(false);
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const [modalEmailIndividual, setModalEmailIndividual] = useState({
        isOpen: false,
        categoriaEmail: '',
        cdCategoriaEmail: null
    });
    const [modalBoletoConfig, setModalBoletoConfig] = useState(false);
    const [modalTelefoneIndividual, setModalTelefoneIndividual] = useState({
        isOpen: false,
        idTelefone: '',
        tipoTelefone: ''
    });
    const [configuracoesBoleto, setConfiguracoesBoleto] = useState({
        agrupaBoleto: cliente.agrupaBoleto,
        boletoDigital: cliente.boletoDigital
    });
    const limiteTotal = cliente.limite;
    const limiteDisponivel = cliente.saldoDisponivel;
    const limiteUtilizado = limiteTotal - limiteDisponivel;

    // Sincroniza as configurações quando o cliente for atualizado
    useEffect(() => {
        setConfiguracoesBoleto({
            agrupaBoleto: cliente.agrupaBoleto,
            boletoDigital: cliente.boletoDigital
        });
    }, [cliente.agrupaBoleto, cliente.boletoDigital]);

    const abrirModalEmail = (categoriaEmail, cdCategoriaEmail) => {
        setModalEmailIndividual({
            isOpen: true,
            categoriaEmail,
            cdCategoriaEmail
        });
    };

    const fecharModalEmail = () => {
        setModalEmailIndividual({
            isOpen: false,
            categoriaEmail: '',
            cdCategoriaEmail: null
        });
    };

    const abrirModalTelefone = (idTelefone, tipoTelefone) => {
        setModalTelefoneIndividual({
            isOpen: true,
            idTelefone,
            tipoTelefone
        });
    };

    const fecharModalTelefone = () => {
        setModalTelefoneIndividual({
            isOpen: false,
            idTelefone: '',
            tipoTelefone: ''
        });
    };

    const handleUnificarBoleto = async (valor) => {
        if (cliente.antecipado) {
            alert("Clientes com antecipado não podem alterar esta configuração.");
            return;
        }

        const confirmacao = window.confirm(
            valor 
                ? "Deseja realmente ativar a agrupação de boletos?"
                : "Deseja realmente desativar a agrupação de boletos?"
        );

        if (confirmacao) {
            try {
                await BoletoService.agruparBoletos(cliente.cdCliente, cliente.digitoCliente, valor);
                
                setConfiguracoesBoleto(prev => ({ ...prev, agrupaBoleto: valor }));
                alert("Configuração de agrupamento de boletos atualizada com sucesso! A alteração pode demorar alguns instantes para ser processada.");
                
                if (onClienteUpdate) {
                    await onClienteUpdate();
                }
            } catch (error) {
                alert("Erro ao atualizar configuração de agrupamento de boletos.");
            }
        }
    };

    const handleBoletoDigital = async (valor) => {
        if (cliente.antecipado) {
            alert("Clientes com antecipado não podem alterar esta configuração.");
            return;
        }

        if (valor) {
            // Se está ativando, abre o modal para configurar o email
            setModalBoletoConfig(true);
        } else {
            // Se está desativando, confirma e atualiza
            const confirmacao = window.confirm("Deseja realmente desativar o boleto digital?");
            if (confirmacao) {
                try {
                    await BoletoService.configurarBoletoDigital(cliente.cdCliente, cliente.digitoCliente, false);
                    
                    setConfiguracoesBoleto(prev => ({ ...prev, boletoDigital: false }));
                    alert("Boleto digital desativado com sucesso! A alteração pode demorar alguns instantes para ser processada.");
                    
                    if (onClienteUpdate) {
                        await onClienteUpdate();
                    }
                } catch (error) {
                    alert("Erro ao desativar boleto digital.");
                }
            }
        }
    };

    return (
        <div className="dashboard">
            <div className="dashboard-content">
                <div className="dashboard-painel dados-cadastrais-painel">
                    <h3 className="titulo">Dados cadastrais</h3>
                    <p className="texto">Todos os seus dados e informações cadastrais.</p>

                    <div className="informacoes bloco">
                        <div className="informacoes-label">
                            <h3 className='titulo'>Informações</h3>
                        </div>
                        <div className="informacoes-detalhes">
                            <div className="informacao-item">
                                <strong>Razão social</strong>
                                <span>{cliente.razaoSocial}</span>
                            </div>
                            <div className="informacao-item">
                                <strong>CNPJ</strong>
                                <span>{formatCNPJ(cliente.cnpj)}</span>
                            </div>
                            <div className="informacao-item">
                                <strong>Códgio GAM</strong>
                                <span>{cliente.cdCliente}-{cliente.digitoCliente}</span>
                            </div>
                            <div className="informacao-item">
                                <strong>
                                    Horário para pedidos{" "}
                                    <Info
                                        data-tooltip-id="tooltip-horario"
                                        data-tooltip-content="Horário máximo para fechamento de pedidos para o dia. Pedidos após este horário serão faturados no próximo movimento."
                                        size={14}
                                        style={{ cursor: "pointer", color: "#143B96", marginLeft: "5px" }}
                                    />
                                    <Tooltip
                                        id="tooltip-horario"
                                        place="top"
                                        effect="solid"
                                        clickable
                                        style={{ zIndex: 9999, maxWidth: "250px", whiteSpace: "normal" }}
                                    />
                                </strong>
                                <span className="horarios-lado-lado">
                                    {cliente.horarioLimitePedido1}h{" "}
                                    <Info
                                        data-tooltip-id="tooltip-horario1"
                                        data-tooltip-content="1 - Dias úteis"
                                        size={12}
                                        style={{ cursor: "pointer", color: "#143B96"}}
                                    />
                                    <Tooltip
                                        id="tooltip-horario1"
                                        place="top"
                                        effect="solid"
                                        clickable
                                        style={{ zIndex: 9999, maxWidth: "200px", whiteSpace: "normal" }}
                                    />
                                    - {cliente.horarioLimitePedido2}h{" "}
                                    <Info
                                        data-tooltip-id="tooltip-horario2"
                                        data-tooltip-content="2 - Final de semana e feriado"
                                        size={12}
                                        style={{ cursor: "pointer", color: "#143B96" }}
                                    />
                                    <Tooltip
                                        id="tooltip-horario2"
                                        place="top"
                                        effect="solid"
                                        clickable
                                        style={{ zIndex: 9999, maxWidth: "200px", whiteSpace: "normal" }}
                                    />
                                </span>
                            </div>
                            <div className="informacao-item">
                                <strong>Prazo de pagamento</strong>
                                <span>{cliente.prazoPagamento} dias</span>
                            </div>
                            <div className="informacao-item">
                                <strong>Centro de distribuição</strong>
                                <span>{cliente.dsEmpresaPadrao}</span>
                            </div>
                            <div className="informacao-item">
                                <strong>Vencimento do alvará</strong>
                                <span>{cliente.vencimentoAlvara}</span>
                            </div>
                            <div className="informacao-item">
                                <strong>Retinóicos</strong>
                                <span>{cliente.bloqueiaRetinoico ? "Bloqueado" : "Liberado"}</span>
                            </div>
                            <div className="informacao-item">
                                <strong>AFE</strong>
                                <span>Inativa</span>
                            </div>
                        </div>
                    </div>

                    <div className="limite-credito bloco">
                        <div className="informacoes-label">
                            <h3 className='titulo'>Limite de crédito e valores</h3>
                        </div>
                        <div className="credito-detalhes">
                            <div className="limite-item">
                                <strong>Limite total</strong>
                                <span>R$ {parseFloat(limiteTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                            <div className="limite-item">
                                <strong>Limite utilizado</strong>
                                <span>R$ {parseFloat(limiteUtilizado).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                            <div className="limite-item">
                                <strong>Limite disponí­vel{" "}
                                    <Info
                                        data-tooltip-id="tooltip-horario"
                                        data-tooltip-content="Os valores podem sofrer alterações conforme faturamentos e pagamentos ocorridos ao longo do dia."
                                        size={14}
                                        style={{ cursor: "pointer", color: "#143B96", marginLeft: "5px" }}
                                    />
                                    <Tooltip
                                        id="tooltip-horario"
                                        place="top"
                                        effect="solid"
                                        clickable
                                        style={{ zIndex: 9999, maxWidth: "250px", whiteSpace: "normal" }}
                                    />
                                </strong>
                                <span>R$ {parseFloat(limiteDisponivel).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                            <div className="limite-item">
                                <strong>Valor minímo primeiro pedido{" "}
                                    <Info
                                        data-tooltip-id="tooltip-horario"
                                        data-tooltip-content="O primeiro pedido do dia deve ter valor igual ou maior ao valor mínimo do primeiro pedido."
                                        size={14}
                                        style={{ cursor: "pointer", color: "#143B96", marginLeft: "5px" }}
                                    />
                                    <Tooltip
                                        id="tooltip-horario"
                                        place="top"
                                        effect="solid"
                                        clickable
                                        style={{ zIndex: 9999, maxWidth: "250px", whiteSpace: "normal" }}
                                    />
                                </strong>
                                <span>R$ {parseFloat(cliente.vlMinimoPrimeiroPedido).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                            <div className="limite-item">
                                <strong>Valor dos demais pedidos</strong>
                                <span>R$ {parseFloat(cliente.vlMinimoOutrosPedido).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                        </div>
                    </div>

                    <div className="contatos bloco">
                        <div className="contatos-label">
                            <h3 className='titulo'>Contatos</h3>
                        </div>
                        <div className="contatos-detalhes">
                            <div className="contato-item">
                                <strong>Gestor</strong>
                                <div className="email-container">
                                    <span>{cliente.emails.find(email => email.dsCategoriaEmail === "GESTOR")?.dsEmail || "N/A"}</span>
                                    <FiEdit
                                        size={14}
                                        style={{ cursor: "pointer", color: "#143B96", marginLeft: "8px" }}
                                        onClick={() => abrirModalEmail("GESTOR", 11)}
                                    /> 
                                </div>
                            </div>
                            <div className="contato-item">
                                <strong>Comprador medicamentos</strong>
                                <div className="email-container">
                                    <span>{cliente.emails.find(email => email.dsCategoriaEmail === "COMPRADOR MEDICAMENTO")?.dsEmail || "N/A"}</span>
                                    <FiEdit
                                        size={14}
                                        style={{ cursor: "pointer", color: "#143B96", marginLeft: "8px" }}
                                        onClick={() => abrirModalEmail("COMPRADOR MEDICAMENTO", 12)}
                                    />
                                </div>
                            </div>
                            <div className="contato-item">
                                <strong>Comprador perfumaria</strong>
                                <div className="email-container">
                                    <span>{cliente.emails.find(email => email.dsCategoriaEmail === "COMPRADOR PERFUMARIA")?.dsEmail || "N/A"}</span>
                                    <FiEdit
                                        size={14}
                                        style={{ cursor: "pointer", color: "#143B96", marginLeft: "8px" }}
                                        onClick={() => abrirModalEmail("COMPRADOR PERFUMARIA", 32)}
                                    />
                                </div>
                            </div>
                            <div className="contato-item">
                                <strong>Whatsapp</strong>
                                <div className="email-container">
                                    <span>{
                                        (cliente.telefones && cliente.telefones
                                            .filter(tel => tel.idTelefone === 'W')
                                            .map(tel => formatTelefone(tel.dsTelefone))
                                            .join(', ')) || 'N/A'
                                    }</span>
                                    <FiEdit
                                        size={14}
                                        style={{ cursor: "pointer", color: "#143B96", marginLeft: "8px" }}
                                        onClick={() => abrirModalTelefone('W', 'Whatsapp')}
                                    />
                                </div>
                            </div> 
                            <div className="contato-item">
                                <strong>Adm/Financeiro</strong>
                                <div className="email-container">
                                    <span>{
                                        (cliente.telefones && cliente.telefones
                                            .filter(tel => tel.idTelefone === 'A')
                                            .map(tel => formatTelefone(tel.dsTelefone))
                                            .join(', ')) || 'N/A'
                                    }</span>
                                    <FiEdit
                                        size={14}
                                        style={{ cursor: "pointer", color: "#143B96", marginLeft: "8px" }}
                                        onClick={() => abrirModalTelefone('A', 'Adm/Financeiro')}
                                    />
                                </div>
                            </div> 
                             
                            <div className="contato-item">
                                <strong>E-mail principal envio NF-e</strong>
                                <span>{cliente.emails.find(email => email.dsCategoriaEmail === "NFE PRINCIPAL")?.dsEmail || "N/A"}</span>
                            </div>
                            <div className="contato-item">
                                <strong>E-mail secundário envio NF-e</strong>
                                <span>{cliente.emails.find(email => email.dsCategoriaEmail === "NFE COPIA")?.dsEmail || "N/A"}</span>
                            </div>
                            <button className="editar-emails-btn" onClick={() => setIsModalOpen(true)}>
                                Editar emails NF-e
                            </button>

                            <ModalNfe isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} cliente={cliente} onClienteUpdate={onClienteUpdate} />


                        </div>
                    </div>


                    <div className="boletos bloco">
                        <div className="boletos-label">
                            <h3 className='titulo'>Boletos</h3>
                        </div>
                        <div className="boletos-detalhes">
                            <div className="boletos-item">
                                <strong>
                                    Agrupar boletos?{" "}
                                    {cliente.antecipado && (
                                        <Info
                                            data-tooltip-id="tooltip-antecipado-agrupar"
                                            data-tooltip-content="Clientes antecipados não podem alterar esta configuração"
                                            size={14}
                                            style={{ cursor: "pointer", color: "#143B96", marginLeft: "5px" }}
                                        />
                                    )}
                                    {cliente.antecipado && (
                                        <Tooltip
                                            id="tooltip-antecipado-agrupar"
                                            place="top"
                                            effect="solid"
                                            clickable
                                            style={{ zIndex: 9999, maxWidth: "250px", whiteSpace: "normal" }}
                                        />
                                    )}
                                </strong>
                                <span>
                                    <label>
                                        <input 
                                            type="radio" 
                                            name="unificar" 
                                            value="sim" 
                                            checked={configuracoesBoleto.agrupaBoleto === true} 
                                            onChange={() => handleUnificarBoleto(true)}
                                            disabled={cliente.antecipado}
                                        /> Sim
                                    </label>
                                    <label>
                                        <input 
                                            type="radio" 
                                            name="unificar" 
                                            value="nao" 
                                            checked={configuracoesBoleto.agrupaBoleto === false} 
                                            onChange={() => handleUnificarBoleto(false)}
                                            disabled={cliente.antecipado}
                                        /> Não
                                    </label>
                                </span>
                            </div>
                            <div className="boletos-item">
                                <strong>
                                    Boleto digital?{" "}
                                    {cliente.antecipado && (
                                        <Info
                                            data-tooltip-id="tooltip-antecipado-boleto"
                                            data-tooltip-content="Clientes antecipados não podem alterar esta configuração"
                                            size={14}
                                            style={{ cursor: "pointer", color: "#143B96", marginLeft: "5px" }}
                                        />
                                    )}
                                    {cliente.antecipado && (
                                        <Tooltip
                                            id="tooltip-antecipado-boleto"
                                            place="top"
                                            effect="solid"
                                            clickable
                                            style={{ zIndex: 9999, maxWidth: "250px", whiteSpace: "normal" }}
                                        />
                                    )}
                                </strong>
                                <span>
                                    <label>
                                        <input 
                                            type="radio" 
                                            name="boleto" 
                                            value="sim" 
                                            checked={configuracoesBoleto.boletoDigital === true} 
                                            onChange={() => handleBoletoDigital(true)}
                                            disabled={cliente.antecipado}
                                        /> Sim
                                    </label>
                                    <label>
                                        <input 
                                            type="radio" 
                                            name="boleto" 
                                            value="nao" 
                                            checked={configuracoesBoleto.boletoDigital === false} 
                                            onChange={() => handleBoletoDigital(false)}
                                            disabled={cliente.antecipado}
                                        /> Não
                                    </label>
                                </span>
                            </div>
                            {configuracoesBoleto.boletoDigital && (
                                <button className="editar-emails-btn" onClick={() => setIsModalBoletoOpen(true)}>
                                    Editar e-mail boleto
                                </button>
                            )}
                            <ModalBoletoDigital isOpen={isModalBoletoOpen} onClose={() => setIsModalBoletoOpen(false)} cliente={cliente} onClienteUpdate={onClienteUpdate} />

                        </div>
                    </div>
                </div>
            </div>

            <ModalEmailIndividual 
                isOpen={modalEmailIndividual.isOpen}
                onClose={fecharModalEmail}
                cliente={cliente}
                categoriaEmail={modalEmailIndividual.categoriaEmail}
                cdCategoriaEmail={modalEmailIndividual.cdCategoriaEmail}
                onClienteUpdate={onClienteUpdate}
            />

            <ModalBoletoConfig 
                isOpen={modalBoletoConfig}
                onClose={() => setModalBoletoConfig(false)}
                cliente={cliente}
                onClienteUpdate={onClienteUpdate}
            />

            <ModalTelefoneIndividual 
                isOpen={modalTelefoneIndividual.isOpen}
                onClose={fecharModalTelefone}
                cliente={cliente}
                idTelefone={modalTelefoneIndividual.idTelefone}
                tipoTelefone={modalTelefoneIndividual.tipoTelefone}
                onClienteUpdate={onClienteUpdate}
            />

        </div>
    );
}

export default DadosCadastrais;
